const PARAM_VALUE = {
  TRUE: 'true',
  FALSE: 'false',
  SURVEY_START_STEP_LABEL: 'Survey start',
  MENU_TYPE_HEADER: 'header',
};

export default PARAM_VALUE;
